import { ReactElement } from 'react';
import DOMPurify from 'dompurify';
import DomainSensitiveLink from '../../../../../../common/domain-sensitive-link/domain-sensitive-link';
import MaterialClickHandler from '../../../../../../common/material-click-handler/material-click-handler';
import handleLinkClick from '../../utils/handle-link-click';
import './material-title.scss';

type MaterialTitleProps = { item: Material; index: number; link: string; internalPath?: string };

const MaterialTitle = (props: MaterialTitleProps): ReactElement => {
    const { item, index, link, internalPath } = props;

    const sanitizedTitle = DOMPurify.sanitize(item.title);

    const onClick = (): void => handleLinkClick({ item, index });

    return (
        <MaterialClickHandler item={item} materialProps={{ itemIndex: index, internalPath }}>
            <h3 className='material-title-wrapper'>
                <DomainSensitiveLink
                    className='material-title'
                    dangerouslySetInnerHTML={{ __html: sanitizedTitle }}
                    href={link}
                    title={item.title}
                    onClick={onClick}
                />
            </h3>
        </MaterialClickHandler>
    );
};

export default MaterialTitle;
